export class ContactTypeResultDto {
  contactTypeId: number;
  displayText: string;
}
